import React, { Component } from "react";
import { Menu, MenuItem } from "material-ui";
import PropTypes from "prop-types";
import UserAvatar from "./UserAvatar";
import { withStylesAndTranslation } from "../utils/container";

const styleSheet = theme => ({
    avatar: {
        margin: theme.spacing.unit,
        cursor: "pointer"
    }
});

class AvatarMenu extends Component {
    state = {
        anchorEl: undefined,
        open: false
    };

    handleClick = event => {
        this.setState({
            open: true,
            anchorEl: event.currentTarget.parentElement
        });
    };

    handleRequestClose = () => {
        this.setState({ open: false });
    };

    closeThenCall = callback => {
        return () => {
            this.handleRequestClose();
            return callback.apply(this, arguments);
        };
    };

    render() {
        const { userSettings, t } = this.props;
        return (
            <div>
                <UserAvatar
                    onClick={this.handleClick}
                    avatarURL={userSettings.avatarURL}
                    displayName={userSettings.displayName}
                    aria-owns={this.state.open ? "simple-menu" : null}
                    aria-haspopup="true"
                />
                <Menu
                    id="simple-menu"
                    anchorEl={this.state.anchorEl}
                    anchorReference="anchorEl"
                    getContentAnchorEl={null}
                    anchorOrigin={{
                        vertical: "bottom",
                        horizontal: "left"
                    }}
                    open={this.state.open}
                    onClose={this.handleRequestClose}>
                    <MenuItem
                        onClick={this.closeThenCall(this.props.handleProfile)}>
                        {t("avatarMenu.Profile")}
                    </MenuItem>
                    <MenuItem
                        onClick={this.closeThenCall(this.props.handleFeedback)}>
                        {t("avatarMenu.Give us feedback")}
                    </MenuItem>
                    <MenuItem
                        onClick={this.closeThenCall(this.props.handleLogout)}>
                        {t("avatarMenu.Logout")}
                    </MenuItem>
                </Menu>
            </div>
        );
    }
}

AvatarMenu.propTypes = {
    classes: PropTypes.object.isRequired,
    handleProfile: PropTypes.func,
    handleLogout: PropTypes.func,
    handleFeedback: PropTypes.func,
    userSettings: PropTypes.object.isRequired,
    t: PropTypes.func.isRequired
};

AvatarMenu.defaultProps = {
    handleProfile: () => {},
    handleLogout: () => {},
    handleFeedback: () => {}
};

export default withStylesAndTranslation(AvatarMenu, styleSheet);



// WEBPACK FOOTER //
// ./src/components/AvatarMenu.jsx